<span class="text-legend-m" [ngClass]="customCssClass"><ng-content></ng-content></span>
